<script>
import bem from '@/utils/bem';

const b = bem('edit-field-modal');

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    modalTitle: {
      type: String,
      default: 'Edit Field',
    },
    modalWidth: {
      type: String,
      default: '500px',
    },
    fields: {
      type: Array,
      default: () => [],
      // Each field: { key, label, placeholder, value, type: 'input' | 'textarea', rows?: number }
    },
    showDelete: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close', 'save', 'delete'],
  data() {
    return {
      localValues: {},
    };
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.localValues = {};
          this.fields.forEach((field) => {
            this.localValues[field.key] = field.value || '';
          });
        }
      },
      immediate: true,
    },
    fields: {
      handler() {
        if (this.visible) {
          this.fields.forEach((field) => {
            if (!(field.key in this.localValues)) {
              this.localValues[field.key] = field.value || '';
            }
          });
        }
      },
      deep: true,
    },
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    handleSave() {
      this.$emit('save', { ...this.localValues });
    },
    handleClose() {
      this.$emit('close');
    },
    handleDelete() {
      this.$emit('delete');
    },
  },
};
</script>

<template>
  <a-modal
    :open="visible"
    :footer="null"
    :width="modalWidth"
    :title="modalTitle"
    @cancel="handleClose"
  >
    <div :class="b()">
      <div
        v-for="field in fields"
        :key="field.key"
        :class="b('field')"
      >
        <span :class="b('label')">{{ field.label }}</span>
        <a-textarea
          v-if="field.type === 'textarea'"
          v-model:value="localValues[field.key]"
          :class="b('textarea')"
          :placeholder="field.placeholder"
          :rows="field.rows || 4"
        />
        <a-input
          v-else
          v-model:value="localValues[field.key]"
          :class="b('input')"
          :placeholder="field.placeholder"
        />
      </div>
      <div :class="b('actions', { withDelete: showDelete })">
        <a-button
          v-if="showDelete"
          type="primary"
          danger
          @click="handleDelete"
        >
          Delete
        </a-button>
        <div :class="b('actions-right')">
          <a-button @click="handleClose">Cancel</a-button>
          <a-button type="primary" @click="handleSave">Save</a-button>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<style scoped lang="scss">
@import '@/styles/variables';
@import '@/styles/media';

.edit-field-modal {
  &__field {
    margin-bottom: 16px;

    @include mediaMinMax(1025, $normal) {
      margin-bottom: vw-full(16);
    }
  }

  &__label {
    display: block;
    font-size: 14px;
    font-weight: 500;
    color: #293241;
    margin-bottom: 8px;

    @include mediaMinMax(1025, $normal) {
      font-size: vw-full(14);
      margin-bottom: vw-full(8);
    }
  }

  &__input,
  &__textarea {
    width: 100%;
    white-space: pre-line;
  }

  &__actions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 24px;

    @include mediaMinMax(1025, $normal) {
      margin-top: vw-full(24);
    }
    &_withDelete {
      justify-content: space-between;
    }
  }

  &__actions-right {
    display: flex;
    gap: 12px;

    @include mediaMinMax(1025, $normal) {
      gap: vw-full(12);
    }
  }
}
</style>
